import {
  Discount,
  DiscountFilter,
  DiscountUpdate,
} from "@happy-legal/graphql-types";
import { graphQlClient } from "../clients";
import {
  MUTATION_ADD_DISCOUNT,
  MUTATION_DELETE_DISCOUNT,
  MUTATION_UPDATE_DISCOUNT,
} from "../gql/mutations";
import { QUERY_GET_ALL_DISCOUNTS } from "../gql/queries";
import { discountInitState } from "../providers/DiscountProvider";
import { handleCatchReducer } from "./handleCatchReducer";

export const GET_ALL_DISCOUNTS = "GET_ALL_DISCOUNTS";
type TGET_ALL_DISCOUNTS = {
  type: "GET_ALL_DISCOUNTS";
  filter?: DiscountFilter;
};

export const ADD_DISCOUNT = "ADD_DISCOUNT";
type TADD_DISCOUNT = {
  type: "ADD_DISCOUNT";
  payload: Discount;
};

export const UPDATE_DISCOUNT = "UPDATE_DISCOUNT";
type TUPDATE_DISCOUNT = {
  type: "UPDATE_DISCOUNT";
  payload: DiscountUpdate;
};

export const DELETE_DISCOUNT = "DELETE_DISCOUNT";
type TDELETE_DISCOUNT = {
  type: "DELETE_DISCOUNT";
  id: string;
};

export type TDiscountAction =
  | TGET_ALL_DISCOUNTS
  | TADD_DISCOUNT
  | TUPDATE_DISCOUNT
  | TDELETE_DISCOUNT;

export const discountReducer = async (
  state: Discount[],
  action: TDiscountAction
) => {
  try {
    switch (action.type) {
      case GET_ALL_DISCOUNTS: {
        const newState = await graphQlClient(QUERY_GET_ALL_DISCOUNTS, {
          filter: action?.filter,
        });

        return newState;
      }

      case ADD_DISCOUNT: {
        const newState = await graphQlClient(MUTATION_ADD_DISCOUNT, {
          input: action.payload,
        }).then((res) => {
          // Add new discount to state
          const newDiscounts = [...state, res];
          return newDiscounts;
        });

        return newState;
      }

      case UPDATE_DISCOUNT: {
        const { id, ...input } = action.payload;

        const newState = await graphQlClient(MUTATION_UPDATE_DISCOUNT, {
          id,
          input,
        }).then((res) => {
          const isUpdatingDiscount = state.some(
            (discount) => discount.id === res.id
          );

          // Update discount via id
          if (isUpdatingDiscount) {
            const updatedDiscounts = state.map((discount) =>
              discount.id === res.id ? res : discount
            );
            return updatedDiscounts;
          }
          // Add new discount to state
          else {
            const newDiscounts = [...state, res];
            return newDiscounts;
          }
        });

        return newState;
      }

      case DELETE_DISCOUNT: {
        await graphQlClient(MUTATION_DELETE_DISCOUNT, {
          id: action.id,
        });

        const newState = state?.filter((discount) => discount.id !== action.id);

        return newState;
      }

      default: {
        return state;
      }
    }
  } catch (err) {
    handleCatchReducer("discount", err);
    return discountInitState;
  }
};
